module.exports = __webpack_public_path__ + "static/media/icon-catalog-download.a5d8d877.svg";